import { Price } from "@/components/Price/Price";
import { useI18n } from "@jog/react-components";
const TotalPriceWrapper = ({ children }) => {
    return <div className="mt-6.25 mb-7.5 flex justify-between font-primary text-lg font-medium">{children}</div>;
};
const PriceWrapper = ({ children }) => {
    return <div className="mb-5 flex justify-between text-sm">{children}</div>;
};
const PaymentFooter = ({ order }) => {
    const { $t } = useI18n();
    return (<div className="mt-7.5 flex flex-col-reverse justify-center lg:flex-row lg:justify-between">
            <div className="w-auto shrink-0 lg:w-[486px]">
                <div className="flex items-center justify-center" id="trustbadgeCustomCheckoutContainer"/>
            </div>
            <div className="w-full lg:ml-10 lg:max-w-[400px]">
                <PriceWrapper>
                    <div>{$t("Subtotal")}:</div>
                    <Price fontSize="18px" price={order.subtotal.centAmount}/>
                </PriceWrapper>
                {order.totalDiscount.centAmount > 0 && (<PriceWrapper>
                        <div>{$t("Discount")}:</div>
                        <Price fontSize="18px" color="#f00" price={order.totalDiscount.centAmount}/>
                    </PriceWrapper>)}
                {order.shippingCosts && order.shippingCosts.costs.centAmount > 0 && (<PriceWrapper>
                        <div>{$t("Shipping costs")}:</div>
                        <Price fontSize="16px" price={order.shippingCosts.costs.centAmount}/>
                    </PriceWrapper>)}
                {order.paymentCosts && order.paymentCosts.centAmount > 0 && (<PriceWrapper>
                        <div>{$t("Payment shipping cost")}:</div>
                        <Price fontSize="16px" price={order.paymentCosts.centAmount}/>
                    </PriceWrapper>)}
                <hr className="border-t border-t-gray-lightSand"/>
                <TotalPriceWrapper>
                    {$t("Total inc. VAT")}
                    <Price fontSize="18px" price={order.total.centAmount}/>
                </TotalPriceWrapper>
            </div>
        </div>);
};
export default PaymentFooter;
